// extracted by mini-css-extract-plugin
module.exports = {"varSpDown2":"0.5rem","message":"message--a1fc5","inlineAlert":"inlineAlert--b6cf5","displayLink":"displayLink--f19ad primary--8529c"};